import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { App } from './App.js';
import { AuthGate } from './auth/AuthGate.js';
import { AuthProvider } from './auth/AuthContext.js';
import './styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('apps/web: #root not found');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Match the P17 discovery cache TTL (30s) — short enough for governance
      // changes to propagate, long enough to absorb IDE chatter.
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AuthGate>
            <App />
          </AuthGate>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
